import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const ETAExpressCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
});

export type ETAExpressCarrierValue = InputProvider.Value<
  typeof ETAExpressCarrierInput
>;

export type ETAExpressCarrierForm = InputProvider.Form<
  typeof ETAExpressCarrierInput
>;

export const ETAExpressCarrierDefault = (): ETAExpressCarrierValue => ({
  apiKey: "",
});

export const CreateETAExpressCarrierForm = memo(
  function CreateETAExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: ETAExpressCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
    );
  },
);
